<template>
  <div>
    <div class="">
      <div class="filter">
        <el-form
          :inline="true"
          @submit.native.prevent
          :model="filter"
          ref="filterForm"
          label-position="right"
          label-width="100px"
          size="small"
          class="oneline"
        >
          <el-form-item label="物资类别">
            <el-select v-model="filter.category">
              <el-option :key="1" label="成品" :value="1"></el-option>
              <el-option :key="2" label="配件" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="成品分类">
            <TemplateSelect
              v-model="filter.product_template_id"
              :category="category"
            ></TemplateSelect>
          </el-form-item> -->
          <el-form-item>
            <el-button
              type="primary"
              size="small"
              @click="
                filter.page = 1
                getData()
              "
              >筛选</el-button
            >
            <!-- <el-button size="small" @click="getData(true)">重置</el-button> -->
          </el-form-item>

          <file-button
            style="float: right"
            obj="well_receiving"
            :filter="queryData"
            :importButton="false"
          ></file-button>
        </el-form>
      </div>
    </div>
    <div class="">
      <Table
        :items="items.list"
        :loading="loading"
        :category="filter.category"
      ></Table>
      <el-pagination
        class="mt-20"
        :page-size="filter.size"
        :current-page.sync="filter.page"
        @current-change="getData(false)"
        layout="total, prev, pager, next"
        :total="items.count"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { drillWellReceiving } from '@/service/getData'
import Table from './table'

export default {
  props: {
    wellid: Number,
  },
  components: {
    Table,
  },
  computed: {
    queryData() {
      let data = this.clone(this.filter)
      data.id = this.wellid
      data.well_id = this.wellid
      data.page -= 1
      return data
    },
  },
  data() {
    return {
      loading: false,
      filter: {
        category: 1,
        page: 1,
        size: 10,
      },
      items: {
        list: [],
        count: 0,
      },
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData(reset = false) {
      if (reset) {
        this.filter.page = 1
      }

      this.loading = true
      let res = await drillWellReceiving(this.queryData)
      if (res.status != 0) return false
      this.items = res.data || []
      this.loading = false
    },
  },
}
</script>
